import { useState, useContext } from "react";
import {
  Box,
  Text,
  Flex,
  Input,
  Button,
  HStack,
  Checkbox,
  Link,
} from "@chakra-ui/react";
import toast from "react-hot-toast";
import { useSession } from "next-auth/react";
import { getAccount } from "utils/sessionHelper";
import { searchPeople } from "controllers/list";
import { getFormattedContacts } from "./utils"
import { MainContext } from "../../context/mainContext";
import { textStyle } from "theme/names";


const isNumeric = (str) => {
  if (typeof str != "string") return false;
  //@ts-ignore
  return !isNaN(str) && !isNaN(parseFloat(str));
};

export function SalesNavSearch({ addPeople }) {
  
  const [postLink, setPostLink] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [like, setLike] = useState<boolean>(false);
  const [reply, setReply] = useState<boolean>(false);
  // const [retweet, setRetweet] = useState<boolean>(false);
  const { data: session } = useSession() ?? {}
  const mainContext: any = useContext(MainContext);

  const handleImport = async () => {

    if (!getAccount(session)?.idLinkedin) {
      mainContext.onOpenGetExtension();
      return;
    }

    if (!postLink) {
      toast.error("Invalid post url");
      return;
    }
    if (!postLink.includes("linkedin.com")) {
      toast.error("Can't read the post, please check your link");
      return;
    }

    setIsLoading(true);

    const dataToSend: any = {
      idUser: getAccount(session)?.id,
      idLinkedin: getAccount(session)?.idLinkedin,
      from: "search",
      search: postLink,
    };

    const data = await searchPeople(session, dataToSend);

    setIsLoading(false);

    if (data?.success === 0) {
      toast.error(data.error);
      return;
    }

    if (data.contacts.length === 0) {
      toast.error(`No one found from this search`);
      return;
    }

    const formattedList = getFormattedContacts(data.contacts)

    setPostLink("");
    setLike(false);
    setReply(false);
    // setRetweet(false);

    addPeople(formattedList);
  };

  return (
    <Box>
      <Text textStyle={textStyle["h4.medium.standard"]}>
        Import people from a Sales Navigator Search
      </Text>
      <Text textStyle={textStyle["body.medium.light"]} mt={1}>
        Will import matching a search on{" "}
        <Link href="https://www.linkedin.com/sales/search/people" isExternal>
          https://www.linkedin.com/sales/search/people
        </Link>
      </Text>
      <Flex mt="4">
        <Input
          // size="sm"
          width="sm"
          value={postLink}
          borderRadius="lg"
          onChange={(e) => setPostLink(e.target.value)}
          isDisabled={isLoading}
          placeholder="https://www.linkedin.com/sales/search/people..."
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              handleImport();
            }
          }}
        />
        <Button ml="4"  onClick={handleImport} isLoading={isLoading} variant="primary">
          Import
        </Button>
      </Flex>
    </Box>
  );
}
